import React from 'react'
import { BrowserRouter, Route } from "react-router-dom"
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { TRANSLATION } from '../constants/state'
import OverviewFilteredMoviesAccess from './OverviewFilteredMoviesAccess'
import OverviewSingleMovieAccess from './OverviewSingleMovieAccess'

const mapStateToProps = (state, ownProps) => ({
    translation: getData(state, TRANSLATION),
})

const getOverviewLangPath = (defaultLang, langKey) => defaultLang === langKey ? '' : '/' + langKey

const PageOverviewAccess = ({
    translation
}) => {
    const languages = translation.languages ? translation.languages : { de: {} }

    const { defaultLang } = translation //???


    return (
        <BrowserRouter>
            {Object.keys(languages).map(langKey => {
                const langPath = getOverviewLangPath(defaultLang, langKey)

                return ([
                    <Route
                        key={langKey + 'overview'}
                        path={langPath + "/:overviewParam"}
                        exact={true}
                        render={props => (
                            <OverviewFilteredMoviesAccess
                                location={props.location}
                            />


                        )}
                    />,
                    <Route
                        key={langKey + 'overview-movie'}
                        path={langPath + "/:overviewParam/movie/:movieParam"}
                        exact={true}
                        render={props => (
                            <OverviewSingleMovieAccess
                                location={props.location}
                            />

                        )}
                    />
                ])
            })}
        </BrowserRouter>
    )

}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(PageOverviewAccess)
